import React, { Component } from "react";
import { connect } from "react-redux";
import { Input } from '../../ui';
import { setClientValue } from "../../../actions";
import { Body } from '../../Common/Form';
import Continue from "../../Common/Continue";
import { validateEmail } from "../../../helpers";
import Text from '../../Common/Form/Text';

import iconUser from '../../../assets/icons/icon-user.svg';
import iconEmail from '../../../assets/icons/icon-email.svg';
import iconNumber from '../../../assets/icons/icon-number.svg';

class AutoForm_1 extends Component {

  constructor(props) {
    super(props);
    this.state = { continue: false };
    this.continueCondition = this.continueCondition.bind(this);
    this.getContent = this.getContent.bind(this);
  }

  componentDidMount() {
    this.checkContinueState(null);
  }

  componentDidUpdate(prevProps, prevState) {
    this.checkContinueState(prevState);
  }

  continueCondition() {

    const {
      name,
      email,
      phoneNumber
    } = this.props;

    return (
      name && email && phoneNumber &&
      name != '' &&
      email != '' &&
      validateEmail(email) &&
      phoneNumber !== '' &&
      phoneNumber.length >= 8 &&
      phoneNumber.length <= 9
    );
  }

  checkContinueState(prevState) {
    if (this.continueCondition()) {
      if (prevState === null || !prevState.continue) this.setState({ continue: true });
    } else {
      if (prevState === null || prevState.continue) this.setState({ continue: false });
    }
  }

  getContent() {

    const {
      name, showError,
      onValueChange, email,
      phoneNumber,
    } = this.props;

    return (
      <div className="AutosStandard-formRow-1">
        <Text style={{ paddingTop: '25px'}} className="Text-question">¿Cómo te llamás?</Text>
        <Input
          id="name"
          name="name"
          //placeholder="Nombre"
          maxLength="50"
          type="text"
          value={name}
          onChange={(event) => { onValueChange('name', event.target.value) }}
          leftIcon={iconUser}
          showAlert={showError && !name}
          autoComplete="nope"
        />
        <Text style={{ paddingTop: '25px'}} className="Text-question">¿Cual es tu dirección de email?</Text>
        <Input
          id="email"
          name="email"
          //placeholder="Email"
          maxLength="50"
          type="email"
          value={email}
          onChange={(event) => { onValueChange('email', event.target.value) }}
          leftIcon={iconEmail}
          showAlert={showError && !validateEmail(email)}
          autoComplete="nope"
        />
        <Text style={{ paddingTop: '25px'}} className="Text-question">¿Cual es tu teléfono?</Text>
        <Input
          id="phoneNumber"
          name="phoneNumber"
          //placeholder="Teléfono"
          maxLength="50"
          type="text"
          value={phoneNumber}
          onChange={(event) => { onValueChange('phoneNumber', event.target.value) }}
          leftIcon={iconNumber}
          showAlert={showError && (!phoneNumber ||
            (phoneNumber.length < 8 || phoneNumber.length > 9))}
          autoComplete="nope"
        />
      </div>
    );
  }

  render() {

    const { continue: toContinue } = this.state;

    return (
      <div>
        <Text style={{ paddingTop: '25px'}} className="Text-question">
          Comencemos por saber un poco de vos:
        </Text>
        <Body columnContent={this.getContent} />
        <Continue state={toContinue}/>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    showError: state.steps.showError,

    name: state.client.name,
    email: state.client.email,
    phoneNumber: state.client.phoneNumber,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onValueChange: (type, value) => {
      dispatch(setClientValue(type, value));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AutoForm_1);